/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import { useParams } from 'react-router-dom'
import { useState, useContext, useEffect } from 'react'
import { Button, FormButton } from '../../components/core/button'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import jsPDF from 'jspdf'
import { font } from '../../utils/font'
import { getWatermarkDataUrl } from '../../utils/watermark'
import { calculateVacation2026 } from '../Calculator2/vacationCalculator2026'

const formatCurrency = (val) => {
  const num = Number(val) || 0
  const [int, dec] = num.toFixed(2).split('.')
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + dec + ' ₼'
}

const Result2 = ({ className }) => {
  const { orta, ay, days, mezun } = useParams()
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [data, setData] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        await PagesAPI.getMagazinePageInfo()
      } catch (e) {}

      // Try reading state from sessionStorage
      let stored = null
      try {
        const raw = sessionStorage.getItem('vacationResult') || sessionStorage.getItem('vacation_calc_2026')
        if (raw) stored = JSON.parse(raw)
      } catch (e) {}

      let baseData = null

      if (stored) {
        baseData = stored.result ? { ...stored.result, ...stored } : stored
      } else {
        // Fallback: recompute from URL params
        const avg = parseFloat(orta) || 1000
        const dWage = parseFloat(ay) || (avg / 30.4)
        const pDays = parseInt(days) || 21
        const gVac = parseFloat(mezun) || (dWage * pDays)

        const fallbackMonths = []
        for (let i = 1; i <= 12; i++) {
          fallbackMonths.push(avg)
        }

        const fallbackRes = calculateVacation2026({
          vacationDays: pDays,
          currentGrossSalary: avg,
          currentMonthWorkedPay: 0,
          monthlySalaries: fallbackMonths,
          sector: 'private_non_oil',
          workplaceType: 'main',
          article102Exemption: 0,
          tradeUnionRate: 0,
        })

        baseData = {
          ...fallbackRes,
          vacationStart: '2026-07-01',
          vacationEnd: '2026-07-21',
          workplaceType: 'main',
          sector: 'private_non_oil',
        }
      }

      // Normalize all properties cleanly
      const normalized = {
        vacationStart: baseData.vacationStart || baseData.holidayInfo?.startDate || '2026-07-01',
        vacationEnd: baseData.vacationEnd || baseData.holidayInfo?.endDate || '2026-07-21',
        returnDate: baseData.holidayInfo?.returnDate || baseData.returnDate || '2026-07-22',
        totalCalendarDays: baseData.holidayInfo?.totalCalendarDays || baseData.totalCalendarDays || baseData.paidDays || 21,
        holidaysCount: baseData.holidayInfo?.holidaysCount || baseData.holidaysCount || 0,
        paidDays: baseData.paidDays || 21,
        averageMonthlyWage: baseData.averageMonthlyWage || 0,
        dailyWage: baseData.dailyWage || 0,
        grossVacationPay: baseData.grossVacationPay || 0,
        currentMonthWorkedPay: baseData.currentMonthWorkedPay || 0,
        totalGross: baseData.totalGrossIncome || baseData.totalGross || ((baseData.grossVacationPay || 0) + (baseData.currentMonthWorkedPay || 0)),
        basicRelief: baseData.standardExemption || baseData.basicRelief || 0,
        taxRelief: baseData.article102Exemption !== undefined ? baseData.article102Exemption : ((baseData.totalExemption || 0) - (baseData.standardExemption || 0)),
        incomeTax: baseData.incomeTax || 0,
        dsmfEmployee: baseData.dsmfEmployee || 0,
        dsmfEmployer: baseData.dsmfEmployer || 0,
        itsEmployee: baseData.itsEmployee || 0,
        itsEmployer: baseData.itsEmployer || 0,
        unemploymentEmployee: baseData.unemploymentEmployee || 0,
        unemploymentEmployer: baseData.unemploymentEmployer || 0,
        unionFee: baseData.tradeUnionFee || baseData.unionFee || 0,
        totalEmployeeDeductions: baseData.totalDeductions || baseData.totalEmployeeDeductions || 0,
        netVacationPay: baseData.netVacationPay || 0,
        netTotalTakeHome: baseData.netIncome || baseData.netTotalTakeHome || 0,
        totalEmployerCost: baseData.totalEmployerCosts || baseData.totalEmployerCost || 0,
        superGross: baseData.superGross || 0,
        salaryGuaranteeApplied: baseData.isProtectedByCurrentSalary || baseData.salaryGuaranteeApplied || false,
        sector: baseData.sector || 'private_non_oil',
        workplaceType: baseData.workplaceType || 'main',
      }

      setData(normalized)
      setLoad(true)
    })()
  }, [orta, ay, days, mezun, language])

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  const generatePdf = async () => {
    if (!data) return
    const watermarkData = await getWatermarkDataUrl()
    const pdf = new jsPDF('p', 'mm', 'a4')
    pdf.addFileToVFS('WorkSans-normal.ttf', font)
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal')
    pdf.setFont('WorkSans')

    // Page 1 Background Watermark (Large format BPG logo, monochrome & subtle)
    if (watermarkData) {
      pdf.addImage(watermarkData, 'PNG', 30, 110, 150, 46)
    }

    // Header
    pdf.setFontSize(16)
    pdf.setTextColor(22, 111, 229)
    pdf.text('BPG CONSULTING CENTRE', 20, 22)

    pdf.setFontSize(13)
    pdf.setTextColor(30, 41, 59)
    pdf.text('Məzuniyyət Haqqı və Vergi Tutulmaları Hesabatı (2026 Standartı)', 20, 31)

    pdf.setFontSize(9)
    pdf.setTextColor(100, 116, 139)
    const workplaceLabel = data.workplaceType === 'main' ? 'Əsas İş Yeri (200 ₼ güzəştlə)' : 'Əlavə İş Yeri'
    const sectorLabel = data.sector === 'public_oil' ? 'Dövlət / Neft sektoru' : 'Qeyri-dövlət və qeyri-neft sektoru'
    pdf.text(`İl: 2026 | Hesablama Tarixi: ${new Date().toLocaleDateString('az-AZ')} | İş Yeri: ${workplaceLabel} | Sektor: ${sectorLabel}`, 20, 38)

    pdf.setDrawColor(226, 232, 240)
    pdf.line(20, 42, 190, 42)

    // Block 1: Məzuniyyət və Günlər
    pdf.setFontSize(11)
    pdf.setTextColor(22, 111, 229)
    pdf.text('1. MƏZUNİYYƏT VƏ İŞ DÖVRÜ MƏLUMATLARI (AR ƏM Maddə 114, 140)', 20, 50)

    let y = 57
    const vacInfoRows = [
      ['Məzuniyyətin Başlama Tarixi:', data.vacationStart || '-'],
      ['Məzuniyyətin Bitmə Tarixi:', data.vacationEnd || '-'],
      ['İşə Başlama (Qayıtma) Tarixi:', data.returnDate || '-'],
      ['Təqvim Günlərinin Cəmi:', `${data.totalCalendarDays || data.paidDays} gün`],
      ['Düşən Bayram Günləri (Ödənilməyən - ƏM Maddə 114):', `${data.holidaysCount || 0} gün`],
      ['Ödənişli Məzuniyyət Günləri:', `${data.paidDays} gün`],
      ['Orta Aylıq Qazanc (Əsas Baza):', formatCurrency(data.averageMonthlyWage)],
      ['Bir Günlük Əməkhaqqı (Baza / 30.4):', formatCurrency(data.dailyWage)],
      ['Qanunvericilik Zəmanəti (ƏM Maddə 111 / 140):', data.salaryGuaranteeApplied ? 'Tətbiq edilib (Cari maaş əsas götürülüb)' : 'Tətbiq edilməyib'],
    ]

    pdf.setFontSize(9)
    vacInfoRows.forEach(([lbl, val]) => {
      pdf.setTextColor(71, 85, 105)
      pdf.text(lbl, 25, y)
      pdf.setTextColor(15, 23, 42)
      pdf.text(String(val), 185, y, { align: 'right' })
      pdf.setDrawColor(241, 245, 249)
      pdf.line(25, y + 2, 185, y + 2)
      y += 6.5
    })

    // Block 2: İşçinin Məzuniyyət Haqqından Tutulmalar
    y += 5
    pdf.setFontSize(11)
    pdf.setTextColor(22, 111, 229)
    pdf.text('2. MUZDLU İŞÇİNİN GƏLİRİ VƏ VERGİ TUTULMALARI (2026)', 20, y)

    y += 7
    const employeeRows = [
      ['Hesablanmış Məzuniyyət Haqqı (Gross):', formatCurrency(data.grossVacationPay)],
      ['Məzuniyyət Ayında İşlənmiş Günlərin Maaşı (Gross):', formatCurrency(data.currentMonthWorkedPay)],
      ['CƏMİ GROSS GƏLİR:', formatCurrency(data.totalGross)],
      ['Vergi Güzəşti (Maddə 102):', formatCurrency(data.taxRelief)],
      ['Baza Güzəşti (Əsas iş yeri - 200 ₼):', formatCurrency(data.basicRelief)],
      ['Gəlir Vergisi (İşçi):', formatCurrency(data.incomeTax)],
      ['DSMF Ayırması (İşçi):', formatCurrency(data.dsmfEmployee)],
      ['İcbari Tibbi Sığorta (İşçi):', formatCurrency(data.itsEmployee)],
      ['İşsizlikdən Sığorta (İşçi - 0.5%):', formatCurrency(data.unemploymentEmployee)],
      ['Həmkarlar İttifaqı Haqqı:', formatCurrency(data.unionFee || 0)],
      ['CƏMİ TUTULMALAR:', formatCurrency(data.totalEmployeeDeductions)],
      ['MƏZUNİYYƏT AYI ÜZRƏ CƏMİ ƏLƏ ÇATAN (NET):', formatCurrency(data.netTotalTakeHome)],
    ]

    pdf.setFontSize(9)
    employeeRows.forEach(([lbl, val]) => {
      pdf.setTextColor(71, 85, 105)
      pdf.text(lbl, 25, y)
      pdf.setTextColor(15, 23, 42)
      pdf.text(String(val), 185, y, { align: 'right' })
      pdf.setDrawColor(241, 245, 249)
      pdf.line(25, y + 2, 185, y + 2)
      y += 6.5
    })

    // Block 3: İşəgötürənin Xərcləri
    y += 5
    pdf.setFontSize(11)
    pdf.setTextColor(13, 148, 136)
    pdf.text('3. İŞƏGÖTÜRƏNİN XƏRCLƏRİ (ŞİRKƏTƏ MAYA DƏYƏRİ)', 20, y)

    y += 7
    const employerRows = [
      ['Hesablanan Cəmi Gross Öhdəlik:', formatCurrency(data.totalGross)],
      ['İşəgötürən DSMF Ayırması:', formatCurrency(data.dsmfEmployer)],
      ['İşəgötürən İcbari Tibbi Sığorta:', formatCurrency(data.itsEmployer)],
      ['İşəgötürən İşsizlikdən Sığorta (0.5%):', formatCurrency(data.unemploymentEmployer)],
      ['İşəgötürənin Sosial Öhdəlikləri Cəmi:', formatCurrency(data.totalEmployerCost)],
      ['CƏMİ MAYA DƏYƏRİ (SUPER GROSS):', formatCurrency(data.superGross)],
    ]

    pdf.setFontSize(9)
    employerRows.forEach(([lbl, val]) => {
      pdf.setTextColor(71, 85, 105)
      pdf.text(lbl, 25, y)
      pdf.setTextColor(15, 23, 42)
      pdf.text(String(val), 185, y, { align: 'right' })
      pdf.setDrawColor(241, 245, 249)
      pdf.line(25, y + 2, 185, y + 2)
      y += 6.5
    })

    // Page 1 Footer Note
    y += 6
    pdf.setFontSize(8)
    pdf.setTextColor(148, 163, 184)
    pdf.text('Hesabat AR Əmək Məcəlləsi (114, 140, 111) və AR Vergi Məcəlləsi (101, 102) əsasında tərtib edilmişdir.', 20, y)
    pdf.text('Ətraflı qanunvericilik izahları növbəti səhifədə təqdim edilir | BPG Consulting Centre (https://bpgconsulting.az)', 20, y + 4.5)

    // PAGE 2: QANUNVERİCİLİK BAZASI
    pdf.addPage()

    // Page 2 Background Watermark (Large format BPG logo, monochrome & subtle)
    if (watermarkData) {
      pdf.addImage(watermarkData, 'PNG', 30, 110, 150, 46)
    }

    pdf.setFontSize(15)
    pdf.setTextColor(22, 111, 229)
    pdf.text('BPG CONSULTING CENTRE', 20, 22)

    pdf.setFontSize(12)
    pdf.setTextColor(30, 41, 59)
    pdf.text('Rəsmi Qanunvericilik Bazası və Hüquqi İzahatlar (2026 Standartı)', 20, 31)

    pdf.setDrawColor(226, 232, 240)
    pdf.line(20, 36, 190, 36)

    let py = 46

    // Section A: AR Əmək Məcəlləsi
    pdf.setFontSize(10.5)
    pdf.setTextColor(22, 111, 229)
    pdf.text('A. AZƏRBAYCAN RESPUBLİKASININ ƏMƏK MƏCƏLLƏSİ', 20, py)
    py += 7

    const emPoints = [
      ['Maddə 114 (İş günü hesab olunmayan bayram günləri):', 'Əmək məzuniyyəti dövrünə təsadüf edən iş günü hesab olunmayan bayram günləri məzuniyyətin təqvim günlərinə daxil edilmir və ödənilmir, lakin işçinin işə qayıtma tarixini bayram günlərinin sayı qədər uzadır.'],
      ['Maddə 140 (Məzuniyyət vaxtı üçün orta əməkhaqqının hesablanması):', 'Məzuniyyət haqqı məzuniyyətə çıxılan aydan əvvəlki son 12 tam təqvim ayının qazancları cəminin 12-yə və 30.4 orta aylıq təqvim günləri əmsalına bölünməsi ilə tapılan bir günlük əməkhaqqının məzuniyyət günlərinə vurulması ilə müəyyən edilir. İşçi 12 aydan az işlədikdə faktiki tam işlənmiş təqvim ayları əsas götürülür.'],
      ['Maddə 111 / NK 126 saylı qərar (Maaşın saxlanması və qanunvericilik zəmanəti):', 'Hesablanmış orta aylıq əməkhaqqı işçinin məzuniyyət dövründəki cari vəzifə maaşından az olduqda, qanunvericilik işçinin mənafeyini qoruyaraq cari vəzifə maaşının əsas baza kimi götürülməsini tələb edir.'],
    ]

    pdf.setFontSize(8.5)
    emPoints.forEach(([title, desc]) => {
      pdf.setTextColor(15, 23, 42)
      pdf.text(title, 22, py)
      py += 4.5
      pdf.setTextColor(71, 85, 105)
      const splitDesc = pdf.splitTextToSize(desc, 168)
      pdf.text(splitDesc, 25, py)
      py += splitDesc.length * 4.2 + 3
    })

    // Section B: AR Vergi Məcəlləsi
    py += 2
    pdf.setFontSize(10.5)
    pdf.setTextColor(22, 111, 229)
    pdf.text('B. AZƏRBAYCAN RESPUBLİKASININ VERGİ MƏCƏLLƏSİ', 20, py)
    py += 7

    const vmPoints = [
      ['Maddə 101.3 (Qeyri-neft/özəl sektorda vergi dərəcəsi):', 'Qeyri-dövlət və qeyri-neft sektorunda muzdlu işçilərin aylıq gəlirindən 8000 manatadək 0%, 8000 manatdan çox olan məbləğdən isə 14% dərəcəsi ilə gəlir vergisi tutulur. Dövlət və neft sektorunda isə 2500 manatadək 14%, artıq hissəyə 25% tətbiq edilir.'],
      ['Maddə 102.1.6 (Əsas iş yerində baza vergi güzəşti):', 'Fiziki şəxsin əsas iş yerində hər hansı muzdlu işlə əlaqədar əldə etdiyi aylıq gəliri 2500 manatadək olduqda, gəlirin 200 manat məbləğində olan hissəsi gəlir vergisindən azad edilir.'],
    ]

    pdf.setFontSize(8.5)
    vmPoints.forEach(([title, desc]) => {
      pdf.setTextColor(15, 23, 42)
      pdf.text(title, 22, py)
      py += 4.5
      pdf.setTextColor(71, 85, 105)
      const splitDesc = pdf.splitTextToSize(desc, 168)
      pdf.text(splitDesc, 25, py)
      py += splitDesc.length * 4.2 + 3
    })

    // Section C: Sosial və Tibbi Sığorta Qanunvericiliyi
    py += 2
    pdf.setFontSize(10.5)
    pdf.setTextColor(22, 111, 229)
    pdf.text('C. SOSİAL, TİBBİ VƏ İŞSİZLİKDƏN SIĞORTA QANUNVERİCİLİYİ', 20, py)
    py += 7

    const insPoints = [
      ['«Sosial sığorta haqqında» AR Qanunu (Maddə 14):', 'Qeyri-neft/özəl sektorda: 200 manatadək hissədən 3% işçi, 22% işəgötürən; 200 manatdan çox hissədən 10% işçi, 15% işəgötürən ödənir. Dövlət və neft sektorunda: 3% işçi, 22% işəgötürən hesablanır.'],
      ['«Tibbi sığorta haqqında» AR Qanunu (İcbari Tibbi Sığorta):', 'Aylıq gəlirin 8000 manatadək hissəsindən 2% işçi, 2% işəgötürən; 8000 manatdan yuxarı hissəsindən isə 0.5% işçi, 0.5% işəgötürən tərəfindən ödənilir.'],
      ['«İşsizlikdən sığorta haqqında» AR Qanunu:', 'Hesablanmış əməkhaqqı fondundan 0.5% işçi və 0.5% işəgötürən tərəfindən sığorta haqqı ödənilir.'],
    ]

    pdf.setFontSize(8.5)
    insPoints.forEach(([title, desc]) => {
      pdf.setTextColor(15, 23, 42)
      pdf.text(title, 22, py)
      py += 4.5
      pdf.setTextColor(71, 85, 105)
      const splitDesc = pdf.splitTextToSize(desc, 168)
      pdf.text(splitDesc, 25, py)
      py += splitDesc.length * 4.2 + 3
    })

    // Page 2 Bottom Stamp & Brand
    py += 5
    pdf.setDrawColor(226, 232, 240)
    pdf.line(20, py, 190, py)
    py += 6
    pdf.setFontSize(8)
    pdf.setTextColor(100, 116, 139)
    pdf.text('BPG Consulting Centre MMC | Hüquq, Vergi və Mühasibatlıq Konsaltinq Mərkəzi', 20, py)
    pdf.text('Vebsayt: https://bpgconsulting.az | Telefon: +994 (55) 424 81 26', 20, py + 4.5)

    pdf.save('BPG_Mezuniyyet_Hesabat_2026.pdf')
  }

  return load && data ? (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={2} data={steps} />
      </div>

      <h1>
        {language === 'AZ'
          ? 'Məzuniyyət Haqqının Hesablanması Nəticəsi (2026 Standartı)'
          : language === 'RU'
          ? 'Результаты расчета отпускных выплат (2026)'
          : language === 'TR'
          ? 'Yıllık İzin Ücreti Hesaplama Sonucu (2026 Standartı)'
          : 'Vacation Pay Calculation Result (2026 Standard)'}
      </h1>

      {/* VACATION DATES BANNER */}
      <div className={styles.vacationBanner}>
        <div className={styles.vacationBannerHeader}>
          <h3>📅 {language === 'AZ' ? 'Məzuniyyət Dövrü və Təqvim Göstəriciləri' : language === 'RU' ? 'Период отпуска и календарные показатели' : language === 'TR' ? 'İzin Dönemi ve Takvim Göstergeleri' : 'Vacation Period & Calendar Indicators'}</h3>
          <span className={styles.sectorBadge}>
            {data.sector === 'public_oil'
              ? (language === 'AZ' ? 'Dövlət / Neft Sektoru' : language === 'RU' ? 'Госсектор / Нефть' : language === 'TR' ? 'Devlet / Petrol Sektörü' : 'Public Sector')
              : (language === 'AZ' ? 'Qeyri-dövlət və Qeyri-neft Sektoru' : language === 'RU' ? 'Частный сектор' : language === 'TR' ? 'Özel ve Petrol Dışı Sektör' : 'Private Sector')}
          </span>
        </div>

        <div className={styles.vacationBannerGrid}>
          <div className={styles.bannerItem}>
            <span>{language === 'AZ' ? 'Məzuniyyətin Başlanğıcı:' : language === 'RU' ? 'Начало отпуска:' : language === 'TR' ? 'İzin Başlangıcı:' : 'Start Date:'}</span>
            <strong>{data.vacationStart || '-'}</strong>
          </div>
          <div className={styles.bannerItem}>
            <span>{language === 'AZ' ? 'Məzuniyyətin Sonu:' : language === 'RU' ? 'Конец отпуска:' : language === 'TR' ? 'İzin Bitişi:' : 'End Date:'}</span>
            <strong>{data.vacationEnd || '-'}</strong>
          </div>
          <div className={styles.bannerItem}>
            <span>{language === 'AZ' ? 'İşə Qayıtma Tarixi:' : language === 'RU' ? 'Дата выхода на работу:' : language === 'TR' ? 'İşe Dönüş Tarihi:' : 'Return to Work:'}</span>
            <strong className={styles.highlightDate}>{data.returnDate || '-'}</strong>
          </div>
          <div className={styles.bannerItem}>
            <span>{language === 'AZ' ? 'Təqvim Günləri Cəmi:' : language === 'RU' ? 'Всего календарных дней:' : language === 'TR' ? 'Toplam Takvim Günü:' : 'Total Calendar Days:'}</span>
            <strong>{data.totalCalendarDays || data.paidDays} {language === 'AZ' ? 'gün' : language === 'RU' ? 'дней' : language === 'TR' ? 'gün' : 'days'}</strong>
          </div>
          <div className={styles.bannerItem}>
            <span>{language === 'AZ' ? 'Düşən Bayram Günləri (Ödənilməyən):' : language === 'RU' ? 'Праздники (без оплаты):' : language === 'TR' ? 'Denk Gelen Tatiller (Ödenmeyen):' : 'Holidays (Unpaid - Art. 114):'}</span>
            <strong className={data.holidaysCount > 0 ? styles.holidayTag : ''}>
              {data.holidaysCount || 0} {language === 'AZ' ? 'gün' : language === 'RU' ? 'дней' : language === 'TR' ? 'gün' : 'days'}
            </strong>
          </div>
          <div className={styles.bannerItem}>
            <span>{language === 'AZ' ? 'Ödənişli Məzuniyyət Günləri:' : language === 'RU' ? 'Оплачиваемые дни отпуска:' : language === 'TR' ? 'Ücretli İzin Günleri:' : 'Paid Vacation Days:'}</span>
            <strong>{data.paidDays} {language === 'AZ' ? 'gün' : language === 'RU' ? 'дней' : language === 'TR' ? 'gün' : 'days'}</strong>
          </div>
          <div className={styles.bannerItem}>
            <span>{language === 'AZ' ? 'Orta Aylıq Qazanc (Baza):' : language === 'RU' ? 'Среднемесячный заработок:' : language === 'TR' ? 'Ortalama Aylık Kazanç (Baz):' : 'Average Monthly Wage:'}</span>
            <strong>{formatCurrency(data.averageMonthlyWage)}</strong>
          </div>
          <div className={styles.bannerItem}>
            <span>{language === 'AZ' ? 'Bir Günlük Əməkhaqqı (Baza / 30.4):' : language === 'RU' ? 'Дневной заработок (База / 30.4):' : language === 'TR' ? 'Bir Günlük Ücret (Baz / 30.4):' : 'Daily Wage:'}</span>
            <strong>{formatCurrency(data.dailyWage)}</strong>
          </div>
        </div>

        {data.salaryGuaranteeApplied && (
          <div className={styles.guaranteeNotice}>
            🛡️ <strong>{language === 'AZ' ? 'Qanunvericilik Zəmanəti Tətbiq Edildi (ƏM Maddə 111 / 140):' : language === 'RU' ? 'Применена гарантия оклада (Ст. 111 / 140):' : language === 'TR' ? 'Yasal Güvence Uygulandı (Madde 111 / 140):' : 'Salary Protection Guarantee Applied:'}</strong>{' '}
            {language === 'AZ'
              ? 'Hesablanmış 12 aylıq orta qazanc cari vəzifə maaşından az olduğu üçün işçinin xeyrinə cari vəzifə maaşı baza olaraq götürülmüşdür.'
              : language === 'RU'
              ? 'Так как средний заработок за 12 месяцев оказался ниже текущего оклада, в пользу работника за основу принят оклад.'
              : language === 'TR'
              ? 'Hesaplanan 12 aylık ortalama kazanç güncel görev maaşından az olduğu için çalışan lehine güncel görev maaşı baz alınmıştır.'
              : 'Average wage was lower than current base salary; current base salary was taken as calculation baseline.'}
          </div>
        )}
      </div>

      {/* TWO FINANCIAL CARDS */}
      <div className={styles.resultGrid}>
        {/* Card 1: Employee */}
        <div className={styles.resultCard}>
          <div className={styles.cardHeader}>
            <h3>
              {language === 'AZ'
                ? 'İşçinin Gəliri və Tutulmalar'
                : language === 'RU'
                ? 'Доход и удержания работника'
                : language === 'TR'
                ? 'Çalışanın Geliri ve Kesintiler'
                : 'Employee Income & Deductions'}
            </h3>
            <span>
              {data.workplaceType === 'main'
                ? (language === 'AZ' ? 'Əsas İş Yeri' : language === 'RU' ? 'Основное место работы' : language === 'TR' ? 'Asıl İş Yeri' : 'Main Workplace')
                : (language === 'AZ' ? 'Əlavə İş Yeri' : language === 'RU' ? 'Дополнительное место работы' : language === 'TR' ? 'Ek İş Yeri' : 'Secondary Workplace')}
            </span>
          </div>

          <div className={styles.mainHighlight}>
            <p>
              {language === 'AZ'
                ? 'Cəmi Ələ Çatan Xalis Gəlir (Net)'
                : language === 'RU'
                ? 'Итого к получению (Net)'
                : language === 'TR'
                ? 'Toplam Ele Geçen Net Gelir (Net)'
                : 'Total Net Take-Home Pay'}
            </p>
            <h2>{formatCurrency(data.netTotalTakeHome)}</h2>
          </div>

          <ul className={styles.breakdownList}>
            <li>
              <span>{language === 'AZ' ? 'Hesablanmış Məzuniyyət Haqqı (Gross):' : language === 'RU' ? 'Начисленные отпускные (Gross):' : language === 'TR' ? 'Brüt İzin Ücreti (Gross):' : 'Gross Vacation Pay:'}</span>
              <strong>{formatCurrency(data.grossVacationPay)}</strong>
            </li>
            {Number(data.currentMonthWorkedPay) > 0 && (
              <li>
                <span>{language === 'AZ' ? 'Ayda İşlənmiş Günlərin Maaşı (Gross):' : language === 'RU' ? 'Зарплата за отработанные дни (Gross):' : language === 'TR' ? 'Çalışılan Günlerin Brüt Maaşı (Gross):' : 'Worked Days Pay (Gross):'}</span>
                <strong>{formatCurrency(data.currentMonthWorkedPay)}</strong>
              </li>
            )}
            <li>
              <span>{language === 'AZ' ? 'Cəmi Gross Gəlir:' : language === 'RU' ? 'Итого Gross доход:' : language === 'TR' ? 'Toplam Brüt Gelir:' : 'Total Gross Income:'}</span>
              <strong>{formatCurrency(data.totalGross)}</strong>
            </li>
            {data.basicRelief > 0 && (
              <li>
                <span>{language === 'AZ' ? 'Baza Vergi Güzəşti (Əsas iş yeri):' : language === 'RU' ? 'Базовая налоговая льгота:' : language === 'TR' ? 'Temel Vergi Muafiyeti (Asıl iş yeri):' : 'Basic Relief (Main workplace):'}</span>
                <strong style={{ color: '#16a34a' }}>-{formatCurrency(data.basicRelief)}</strong>
              </li>
            )}
            {data.taxRelief > 0 && (
              <li>
                <span>{language === 'AZ' ? 'Vergi Məcəlləsi Güzəşti (Maddə 102):' : language === 'RU' ? 'Налоговая льгота (Ст. 102):' : language === 'TR' ? 'Vergi Kanunu Muafiyeti (Madde 102):' : 'Tax Exemption (Art. 102):'}</span>
                <strong style={{ color: '#16a34a' }}>-{formatCurrency(data.taxRelief)}</strong>
              </li>
            )}
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'Gəlir Vergisi (İşçi):' : language === 'RU' ? 'Подоходный налог (Работник):' : language === 'TR' ? 'Gelir Vergisi (Çalışan):' : 'Income Tax:'}</span>
              <strong>-{formatCurrency(data.incomeTax)}</strong>
            </li>
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'DSMF Ayırması (İşçi):' : language === 'RU' ? 'Соцстрах (Работник):' : language === 'TR' ? 'Sosyal Güvenlik Payı (Çalışan):' : 'Social Insurance (DSMF):'}</span>
              <strong>-{formatCurrency(data.dsmfEmployee)}</strong>
            </li>
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'İcbari Tibbi Sığorta (İşçi):' : language === 'RU' ? 'Медстрахование (Работник):' : language === 'TR' ? 'Sağlık Sigortası (Çalışan):' : 'Mandatory Health Ins. (ITS):'}</span>
              <strong>-{formatCurrency(data.itsEmployee)}</strong>
            </li>
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'İşsizlikdən Sığorta (İşçi - 0.5%):' : language === 'RU' ? 'Страхование от безработицы (0.5%):' : language === 'TR' ? 'İşsizlik Sigortası (%0.5):' : 'Unemployment Ins. (0.5%):'}</span>
              <strong>-{formatCurrency(data.unemploymentEmployee)}</strong>
            </li>
            {Number(data.unionFee) > 0 && (
              <li className={styles.minus}>
                <span>{language === 'AZ' ? 'Həmkarlar İttifaqı Haqqı:' : language === 'RU' ? 'Профсоюзный взнос:' : language === 'TR' ? 'Sendika Aidatı:' : 'Trade Union Fee:'}</span>
                <strong>-{formatCurrency(data.unionFee)}</strong>
              </li>
            )}
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'Cəmi Tutulmalar:' : language === 'RU' ? 'Всего удержаний:' : language === 'TR' ? 'Toplam Kesintiler:' : 'Total Deductions:'}</span>
              <strong>-{formatCurrency(data.totalEmployeeDeductions)}</strong>
            </li>
            <li className={styles.finalRow}>
              <span>{language === 'AZ' ? 'Məzuniyyət Ayı Üzrə Cəmi Ələ Çatan (Net):' : language === 'RU' ? 'Итого к получению на руки (Net):' : language === 'TR' ? 'İzin Ayında Toplam Ele Geçen (Net):' : 'Total Net Take-Home:'}</span>
              <strong>{formatCurrency(data.netTotalTakeHome)}</strong>
            </li>
          </ul>
        </div>

        {/* Card 2: Employer */}
        <div className={styles.resultCard}>
          <div className={styles.cardHeader}>
            <h3>
              {language === 'AZ'
                ? 'İşəgötürənin Xərcləri'
                : language === 'RU'
                ? 'Расходы работодателя'
                : language === 'TR'
                ? 'İşverenin Maliyetleri'
                : 'Employer Costs'}
            </h3>
            <span style={{ background: '#f0fdf4', color: '#0d9488' }}>
              {language === 'AZ' ? 'Şirkətə Maya Dəyəri' : language === 'RU' ? 'Затраты компании' : language === 'TR' ? 'Şirket Maliyeti' : 'Cost to Company'}
            </span>
          </div>

          <div className={`${styles.mainHighlight} ${styles.employerHighlight}`}>
            <p>
              {language === 'AZ'
                ? 'Cəmi Maya Dəyəri (Super Gross)'
                : language === 'RU'
                ? 'Общие затраты (Super Gross)'
                : language === 'TR'
                ? 'Toplam Maliyet (Super Gross)'
                : 'Super Gross (Total Cost)'}
            </p>
            <h2>{formatCurrency(data.superGross)}</h2>
          </div>

          <ul className={styles.breakdownList}>
            <li>
              <span>{language === 'AZ' ? 'Hesablanan Cəmi Gross Öhdəlik:' : language === 'RU' ? 'Всего начисленный Gross:' : language === 'TR' ? 'Hesaplanan Toplam Brüt Yükümlülük:' : 'Total Gross Obligation:'}</span>
              <strong>{formatCurrency(data.totalGross)}</strong>
            </li>
            <li>
              <span>{language === 'AZ' ? 'İşəgötürən DSMF Ayırması:' : language === 'RU' ? 'Соцстрах работодателя:' : language === 'TR' ? 'İşveren Sosyal Güvenlik Payı:' : 'Employer Social Ins. (DSMF):'}</span>
              <strong>+{formatCurrency(data.dsmfEmployer)}</strong>
            </li>
            <li>
              <span>{language === 'AZ' ? 'İşəgötürən İcbari Tibbi Sığorta:' : language === 'RU' ? 'Медстрахование работодателя:' : language === 'TR' ? 'İşveren Sağlık Sigortası:' : 'Employer Health Ins. (ITS):'}</span>
              <strong>+{formatCurrency(data.itsEmployer)}</strong>
            </li>
            <li>
              <span>{language === 'AZ' ? 'İşəgötürən İşsizlikdən Sığorta (0.5%):' : language === 'RU' ? 'Безработица работодателя (0.5%):' : language === 'TR' ? 'İşveren İşsizlik Sigortası (%0.5):' : 'Employer Unemployment Ins. (0.5%):'}</span>
              <strong>+{formatCurrency(data.unemploymentEmployer)}</strong>
            </li>
            <li style={{ borderTop: '1px dashed #cbd5e1', paddingTop: '10px' }}>
              <span>{language === 'AZ' ? 'İşəgötürənin Sosial Öhdəlikləri Cəmi:' : language === 'RU' ? 'Итого соцобязательства работодателя:' : language === 'TR' ? 'İşverenin Toplam Sosyal Yükümlülükleri:' : 'Total Employer Social Costs:'}</span>
              <strong style={{ color: '#0d9488' }}>+{formatCurrency(data.totalEmployerCost)}</strong>
            </li>
            <li className={styles.finalRow}>
              <span>{language === 'AZ' ? 'ŞİRKƏTƏ CƏMİ MAYA DƏYƏRİ:' : language === 'RU' ? 'ИТОГОВЫЕ ЗАТРАТЫ КОМПАНИИ:' : language === 'TR' ? 'ŞİRKETE TOPLAM MALİYET:' : 'TOTAL COST TO COMPANY:'}</span>
              <strong style={{ color: '#0d9488' }}>{formatCurrency(data.superGross)}</strong>
            </li>
          </ul>
        </div>
      </div>

      {/* LEGAL NOTES ON PAGE */}
      <div className={styles.legalBox}>
        <h4>📜 {language === 'AZ' ? 'Qanunvericilik Maddələri və Hesablama Standartları' : language === 'RU' ? 'Статьи законодательства и стандарты расчета' : language === 'TR' ? 'Mevzuat Maddeleri ve Hesaplama Standartları' : 'Legal Articles & Standards'}</h4>
        <div className={styles.legalGrid}>
          <div className={styles.legalItem}>
            <strong>{language === 'AZ' ? 'AR Əmək Məcəlləsi Maddə 114:' : language === 'RU' ? 'Ст. 114 Трудового кодекса:' : language === 'TR' ? 'İş Kanunu Madde 114:' : 'Labor Code Art. 114:'}</strong>
            <p>
              {language === 'AZ' ? 'Məzuniyyət dövrünə təsadüf edən bayram günləri məzuniyyətin təqvim günlərinə daxil edilmir, ödənilmir və işə qayıtma tarixini uzadır.' :
               language === 'RU' ? 'Праздничные дни, приходящиеся на период отпуска, не включаются в оплачиваемые дни и продлевают отпуск.' :
               language === 'TR' ? 'İzin dönemine denk gelen tatil günleri izin günlerine dahil edilmez, ödenmez ve işe dönüş tarihini uzatır.' :
               'Holidays falling within the vacation period are not included in calendar days, are unpaid, and extend the return to work date.'}
            </p>
          </div>
          <div className={styles.legalItem}>
            <strong>{language === 'AZ' ? 'AR Əmək Məcəlləsi Maddə 140:' : language === 'RU' ? 'Ст. 140 Трудового кодекса:' : language === 'TR' ? 'İş Kanunu Madde 140:' : 'Labor Code Art. 140:'}</strong>
            <p>
              {language === 'AZ' ? 'Orta əməkhaqqı son 12 tam təqvim ayının qazanclarının 12-yə və 30.4 əmsalına bölünməsi ilə hesablanan 1 günlük əməkhaqqı əsasında tapılır.' :
               language === 'RU' ? 'Среднемесячный заработок рассчитывается делением дохода за 12 месяцев на 12 и коэффициент 30.4 для нахождения однодневной ставки.' :
               language === 'TR' ? 'Ortalama ücret, son 12 tam takvim ayı kazançlarının 12\'ye ve 30.4 katsayısına bölünmesiyle bulunan günlük ücret üzerinden hesaplanır.' :
               'Average wage is calculated based on daily wage found by dividing earnings of last 12 months by 12 and the 30.4 factor.'}
            </p>
          </div>
          <div className={styles.legalItem}>
            <strong>{language === 'AZ' ? 'AR Əmək Məcəlləsi Maddə 111:' : language === 'RU' ? 'Ст. 111 Трудового кодекса:' : language === 'TR' ? 'İş Kanunu Madde 111:' : 'Labor Code Art. 111:'}</strong>
            <p>
              {language === 'AZ' ? '12 aylıq orta qazanc cari vəzifə maaşından az olduqda, qanunvericilik zəmanəti olaraq cari vəzifə maaşı əsas baza götürülür.' :
               language === 'RU' ? 'Если 12-месячный средний заработок меньше текущего оклада, то за основу принимается оклад.' :
               language === 'TR' ? '12 aylık ortalama kazanç güncel görev maaşından az olduğunda, yasal güvence gereği güncel görev maaşı esas alınır.' :
               'When the 12-month average wage is less than current base salary, the current base salary is taken as statutory guarantee baseline.'}
            </p>
          </div>
          <div className={styles.legalItem}>
            <strong>{language === 'AZ' ? 'AR Vergi Məcəlləsi Maddə 101 & 102:' : language === 'RU' ? 'Ст. 101 и 102 Налогового кодекса:' : language === 'TR' ? 'Vergi Kanunu Madde 101 ve 102:' : 'Tax Code Art. 101 & 102:'}</strong>
            <p>
              {language === 'AZ' ? 'Özəl sektorda 8000 ₼-dək 0% gəlir vergisi; əsas iş yerində aylıq gəlir 2500 ₼-dək olduqda 200 ₼ baza vergi güzəşti tətbiq edilir.' :
               language === 'RU' ? 'В частном секторе до 8000 ₼ ставка 0%; на основном месте работы при доходе до 2500 ₼ действует льгота 200 ₼.' :
               language === 'TR' ? 'Özel sektörde 8000 ₼\'ye kadar %0 gelir vergisi; asıl iş yerinde aylık gelir 2500 ₼\'ye kadar olduğunda 200 ₼ temel muafiyet uygulanır.' :
               'In the private sector up to 8000 ₼ income tax is 0%; at main workplace, if income is up to 2500 ₼, a 200 ₼ exemption applies.'}
            </p>
          </div>
        </div>
      </div>

      {/* ACTION BUTTONS */}
      <div className={styles.buttons}>
        <Button to={'/useful/calculator/2'}>{translate.again[language] || translate.again.AZ}</Button>
        <FormButton onClick={generatePdf}>
          📄 {language === 'AZ' ? 'Rəsmi PDF Hesabatı Yüklə' : language === 'RU' ? 'Скачать отчет PDF' : language === 'TR' ? 'Resmi PDF Raporunu İndir' : 'Download Official PDF'}
        </FormButton>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Result2
